import styled, { css } from 'styled-components'

export const LayoutWrapper = styled.div`
  ${({ theme }) => css`
    margin: 56px auto;
    max-width: ${theme.ToRem(1440)};

    @media only screen and (min-width: 1024px) {
      margin: 80px auto 0px;
    }
  `};
`

export const LayoutTitlesContainer = styled.div`
  ${({ theme, showAlways }) => css`
    display: ${showAlways ? 'block' : 'none'};
    padding: 2rem 5vw;
    margin-top: 2rem;

    @media (max-height: 800px) {
      display: block;
    }

    @media only screen and (min-width: ${theme.ToRem(1024)}) {
      display: block;
      padding: 0 3rem 2rem;
    }

    @media (min-width: ${theme.ToRem(1200)}) {
      padding: 0 7rem 2%;
    }
  `}
`

export const LayoutTitle = styled.div`
  ${({ theme, forgotDetails }) => css`
    ${theme.fonts.black};
    color: ${forgotDetails ? theme.colors.dark : theme.colors.primary.default};
    font-size: 1.5rem;
    line-height: 1.5;

    @media only screen and (min-width: ${theme.ToRem(480)}) {
      font-size: 2rem;
      padding-top: 2rem;
    }
  `}
`

export const LayoutSubtitle = styled.div`
  ${({ theme }) => css`
    ${theme.fonts.regular};
    ${theme.colors.dark};
    line-height: 1.5;

    @media only screen and (min-width: ${theme.ToRem(480)}) {
      font-size: 1.5rem;
    }
  `}
`

export const LayoutContentWrapper = styled.div``
